import { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "../Components/Footer";
import { get } from "../API/api_helper";
import CompanyModal from "../Modals/CompanyModal";

function Index() {
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const checkCompany = async () => {
      try {
        const res = await get("/organizations/check");
        if (!res.exists) {
          setShowCompanyModal(true);
        }
      } catch (err) {
        console.error("Error checking company:", err);
      } finally {
        setLoading(false);
      }
    };
    checkCompany();
  }, []);
  if (loading) return <p>Loading...</p>;
  return (
    <>
      <div className="app-wrapper">
        <Navbar />
        <Sidebar />
        <main className="app-main">
          <div className="app-content-header"></div>
          <div className="app-content">
            <div className="container-fluid">
              <Outlet />
            </div>
          </div>
          <CompanyModal
            test="index"
            show={showCompanyModal}
            onHide={() => setShowCompanyModal(false)}
          />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default Index;
